/**
 * This code needs to load before ReactDOM is loaded, so it needs to be in a
 * separate module that loads in the preview before that.
 */
const {
	createSignatureFunctionForTransform,
	getRefreshReg,
	injectIntoGlobalHook,
	validateRefreshBoundaryAndEnqueueUpdate,
} = require("./reactRefreshRuntime.ts")
const unsafeWindow = window as unknown as Record<string, unknown>
// This is being used by modules/compiler.ts to facilitate fastRefresh
unsafeWindow.reactRefreshRuntime = {
	getRefreshReg,
	createSignatureFunctionForTransform,
	validateRefreshBoundaryAndEnqueueUpdate,
}
// Must be imported & injected before loading ReactDOM
injectIntoGlobalHook(unsafeWindow)

// Suggested by React team Fast Refresh implementation
unsafeWindow.$RefreshReg$ = () => {}
// biome-ignore lint/suspicious/noExplicitAny: @TODO add explanation
unsafeWindow.$RefreshSig$ = () => (type: any) => type
